import { Phone } from 'lucide-react'
import { useSipStore } from '../store/sip'
import { retrySip } from '../lib/sip'

export function SipStatusIcon() {
  const { status, hasCredentials } = useSipStore()

  // No credentials — show grayed icon with tooltip
  if (!hasCredentials) {
    return (
      <div className="relative group">
        <div className="p-2 rounded-full">
          <Phone className="w-5 h-5 text-gray-400" />
        </div>
        <div className="absolute right-0 top-9 z-50 hidden group-hover:block bg-gray-800 text-white text-xs rounded px-2 py-1 whitespace-nowrap pointer-events-none">
          You don't have a call account
        </div>
      </div>
    )
  }

  if (status === 'registered') {
    return (
      <div className="relative group">
        <div className="p-2 rounded-full">
          <Phone className="w-5 h-5 text-green-500" />
        </div>
        <div className="absolute right-0 top-9 z-50 hidden group-hover:block bg-gray-800 text-white text-xs rounded px-2 py-1 whitespace-nowrap pointer-events-none">
          SIP connected
        </div>
      </div>
    )
  }

  // connecting or disconnected — red, clickable to retry
  const label = status === 'connecting' ? 'SIP connecting…' : 'SIP disconnected — click to retry'
  return (
    <div className="relative group">
      <button
        onClick={retrySip}
        className="p-2 rounded-full hover:bg-red-50 transition-colors"
        aria-label={label}
      >
        <Phone className="w-5 h-5 text-red-500" />
      </button>
      <div className="absolute right-0 top-9 z-50 hidden group-hover:block bg-gray-800 text-white text-xs rounded px-2 py-1 whitespace-nowrap pointer-events-none">
        {label}
      </div>
    </div>
  )
}
